<div class="modal-header border-0">
  <button type="button" class="btn-close" (click)="modal.dismiss()">
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="custom-scroll-parent gpx-8">
  <div class="modal-body custom-scroll gpx-16 gpx-sm-64 gpb-0">
    <h6 class="h6-bold modal-title w-100 gmb-24">
      {{ 'RESULTS.ADD.HEART_RATE_INSCTURCTIONS.TITLE' | translate }}
    </h6>
    <p class="p3-regular text-secondary gmb-24">
      {{ 'RESULTS.ADD.HEART_RATE_INSCTURCTIONS.DESCRIPTION' | translate }}
    </p>
    <p class="p3-semibold gmb-0">
      {{ 'RESULTS.ADD.HEART_RATE_INSCTURCTIONS.SUBTITLE' | translate }}
    </p>
    <div class="gmb-48 gmb-sm-56">
      <div class="d-flex gmt-8" *ngFor="let step of [1, 2, 3, 4]">
        <span class="p3-semibold text-secondary gpr-16">{{step}}.</span>
        <p class="p3-regular text-secondary gmb-0">
          {{ ('RESULTS.ADD.HEART_RATE_INSCTURCTIONS.STEP' + step) | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
